import Valuable from './valuable'
import Pattern from './pattern'

export default class PatternValuble extends Valuable {
  constructor (pattern, type = undefined) {
    super()
    this.pattern = (pattern instanceof Pattern) ? pattern : new Pattern(pattern)
    this.type = type
  }

  match (raw, type) {
    return this.pattern.match(raw) && (!type || type === 'any' || type === 'formula' || !this.type || this.type === 'any' || this.type === type) && ((type === 'procedure') === (this.type === 'procedure'))
  }

  deriveRawParams (raw) {
    return this.pattern.extract(raw).reduce((all, param) => ({ ...all, [param.name]: param.value }), { })
  }

  async deriveParams ({ character, raw, ui, context }) {
    const params = this.pattern.extract(raw)
    const results = {}
    for (const param of params) {
      const { name, type, value } = param
      if (param.raw) {
        results[name] = character.getValueFromType(value, type)
      } else {
        results[name] = await character.get(value, { ui, type, context })
      }
    }
    return results
  }
}
